module.exports = __webpack_public_path__ + "static/media/resident_avatar_female.a619a9cc.png";